import { render, staticRenderFns } from "./LittleGate.vue?vue&type=template&id=2671cb41&scoped=true"
import script from "./LittleGate.vue?vue&type=script&lang=ts"
export * from "./LittleGate.vue?vue&type=script&lang=ts"
import style0 from "./LittleGate.vue?vue&type=style&index=0&id=2671cb41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2671cb41",
  null
  
)

export default component.exports